module.exports = __webpack_public_path__ + "img/AP_logo_esteso_famiglie.1e35d394.svg";